import { render } from "./TrashBar.vue?vue&type=template&id=b1ad3864&ts=true"
import script from "./TrashBar.vue?vue&type=script&lang=ts"
export * from "./TrashBar.vue?vue&type=script&lang=ts"

import "./TrashBar.vue?vue&type=style&index=0&id=b1ad3864&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__